import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import {
  makeStyles,
  Grid
} from '@material-ui/core';

import { SIREN_CONFIG, USERAUTH_ADMIN } from "config.js";
import {useSelector} from 'react-redux';


import {CardView} from "./components"


const useStyles = makeStyles((theme) => ({
  root: {
    // padding: theme.spacing(1),
    // height: "90vh",
    flexGrow: 1,
  },
}));


const RoomsCardView = props => {

    const { className, history, ...rest } = props;

    const classes = useStyles();

    const [roomList, setRoomList] = useState([]);
    const [roomNameList, setRoomNameList] = useState([]);
    const facility_id = useSelector((store) => store.user.facility_id);
    const facility_name = useSelector((store) => store.user.facility_name);

    const userAuth = useSelector((state) => state.user.admin_type);


    /**
     * 모든 시설의 모든 룸의 센서리스트를 가져오기
     * for 슈퍼관리자
     */
    const loadAllRoomListWithSensor = async() => {

      //이미 로딩했으면, pass함
      // if (roomList.length > 0) {
      //     return roomList;
      // }

      var url = `${SIREN_CONFIG.HOSTNAME}/room/allRoomListWithSensor`;
      const opt = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      };


      let rooms = {};
      let devicelist = [];
      let prev_roomid = '';

      let roomNames = [];

      fetch(url, opt)
      .then(res => res.json())
      .then( responseData => {

        responseData.resultData.map(function (row) {
          var facility_id = row['facility_id'];
          var facility_name = row['facility_name'];
          var roomId = row['roomId'];
          var roomName = row['roomName'];

          if (prev_roomid === '' || prev_roomid !== roomId){
            //새로운 room 정보
            devicelist = [];
            rooms[ roomId ] = devicelist;

            roomNames.push ( {roomId: roomId, roomName :  facility_name + ' - ' + roomName} );
          } else {
            devicelist = rooms[ roomId ];
          }

          devicelist.push( {
            facility_id: facility_id,
            facility_name: facility_name,
            roomId: roomId,
            roomName : roomName,
            deviceId: row['deviceId'],
            installed_pos_detail: row['installed_pos_detail'],
            keepOnFall: row['keepOnFall'],
            status:''}  );

          prev_roomid = roomId;

        });

        // console.log("rooms: ", rooms);
        setRoomList( rooms );
        setRoomNameList(roomNames);
      });
    }


    /**
     * 해당 시설의 모든 룸 센서리스트를 가져오기
     * for 일반관리자
     * @returns 
     */
    const loadRoomListWithSensor = async() => {

      //이미 로딩했으면, pass함
      if (roomList.length > 0) {
          return roomList;
      }

      var url = `${SIREN_CONFIG.HOSTNAME}/room/roomListWithSensor?facility_id=${facility_id}`;
      const opt = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      };

      let rooms = {};
      let devicelist = [];
      let prev_roomid = '';

      let roomNames = [];

      fetch(url, opt)
      .then(res => res.json())
      .then( responseData => {

        responseData.resultData.map(function (row) {
          var roomId = row['roomId'];
          var roomName = row['roomName'];

          if (prev_roomid === '' || prev_roomid !== roomId){
            //새로운 room 정보
            devicelist = [];
            rooms[ roomId ] = devicelist;

            roomNames.push ( {roomId: roomId, roomName : roomName} );
          } else {
            devicelist = rooms[ roomId ];
          }

          devicelist.push( {
            facility_id: facility_id,
            facility_name: facility_name,
            roomId: roomId,
            roomName : roomName,
            deviceId: row['deviceId'],
            installed_pos_detail: row['installed_pos_detail'],
            keepOnFall: row['keepOnFall'],
            status:''}  );

          prev_roomid = roomId;
        });

        // console.log("rooms: ", rooms);
        setRoomList( rooms );
        setRoomNameList(roomNames);
      });
    }


    useEffect(() => {

      if ( userAuth === USERAUTH_ADMIN){
        //슈퍼 관리자
        loadAllRoomListWithSensor();
      } else {
        //일반 시설 관리자
        loadRoomListWithSensor();

      }
    }, []);


    return (
      <div className={classes.root}>
        <Grid container spacing={1}>

          {roomNameList.map((data) => (
            <Grid item xl={2} lg={3} md={4} xs={6} key={data.roomId}>
              <CardView roomId={data.roomId} roomName={data.roomName} dataList={roomList[data.roomId]} />
            </Grid>
          ))}
        </Grid>
      </div>
    );
}


RoomsCardView.propTypes = {
  className: PropTypes.string
};

export default RoomsCardView;
